// import { decryptData, encryptData } from "middleware/encryption"
import appConfig from "Api/app.config"
import { useEffect, useState } from "react"

const useApi = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [isConnected, setIsConnected] = useState(window.navigator.onLine);

  const SkipRouts = ["User/login", 'Booking/send-whatsapp-message', "Report/booking-invoice?bookingId", "Report/sale-invoice?saleId", "Inquiry/create", "Report/credit-note-print?creditNoteId", "Report/export-delivery-report", "Report/export-income-expense-report"]

  const routsBaseURLChange = ["DrawRequirement/update", 'DrawRequirement/create', "DrawRequirement/list", "DrawRequirement/delete?id", "DrawRequirement/mark-as-done"]

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsConnected(true);
    };

    const handleOfflineStatusChange = () => {
      setIsConnected(false);
    };

    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOfflineStatusChange);

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOfflineStatusChange);
    };
  }, []);


  useEffect(() => {
    localStorage.getItem("authuser")
  }, [])

  const getApi = async (route, searchText) => {

    try {
      setLoading(true)

      const obj = localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser"))
        : ""

      const headers = new Headers()
      headers.append("Authorization", `Bearer ${obj.Token}`)
      headers.append("accept", "*/*")
      headers.append("searchText", searchText)

      const requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: "follow",
      }
      const value = route.split("=")[1] || ''
      const IsSkipData = SkipRouts?.some(option => option.includes(route.split("=")[0]))
      const IsBaseURLChange = routsBaseURLChange?.some(option => option.includes(route.split("=")[0]))
      // const encodedValue =
      //   value == undefined
      //     ? ""
      //     // : encodeURIComponent(await encryptData(obj, value))
      //     : encodeURIComponent(obj, value)
      const queryParameter =
        route.split("=")[0] + (value == "" ? "" : "=" + value)

      const response = await fetch(
        `${IsBaseURLChange ? appConfig.TM_BASE_URL : appConfig.BASE_URL}/${IsSkipData ? route : queryParameter}`,
        requestOptions
      )

      if (response.status === 200) {
        if (IsSkipData) {
          const data = await response.text()
          return { data, status: response.status }
        } else {
          const data = JSON.parse(await response.text(), obj)
          return { data, status: response.status }
        }
      } else if (response.status === 401) {
        localStorage.clear()
        location.reload()
      } else {
        if (IsSkipData) {
          const data = await response.text()
          return { data, status: response.status }
        } else {
          // const data = await decryptData(obj, await response.text())
          const data = (obj, await response.text())
          return { data, status: response.status }
        }
      }
    } catch (error) {
      return { data: `${isConnected ? "Please kindly contact the administrator for further assistance" : "Check Your Internet"}`, status: 505 }
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  const postApi = async (route, body) => {
    try {
      setLoading(true)

      const obj = localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser"))
        : ""

      const headers = new Headers()
      headers.append("accept", "*/*")
      headers.append("Authorization", `Bearer ${obj?.Token}`)
      headers.append("Content-Type", "application/json")

      const IsSkipData = SkipRouts?.some(option => option.includes(route))
      const IsBaseURLChange = routsBaseURLChange?.some(option => option.includes(route))
      const IsSkipUserLogin = route == "User/login" || route == "Inquiry/create"


      const raw = JSON.stringify(body)

      const requestOptions = {
        method: 'POST',
        headers: headers,
        body: IsSkipData ? raw : (obj, raw),
        // body: IsSkipData ? raw : await encryptData(obj, raw),
        redirect: "follow",
      }

      const response = await fetch(
        `${IsBaseURLChange ? appConfig.TM_BASE_URL : appConfig.BASE_URL}/${route}`,
        requestOptions
      )

      if (response.status === 200) {
        if (IsSkipData) {
          const data = IsSkipUserLogin ? await response.json() : await response.text();
          return { data, status: response.status }
        } else {
          const data = JSON.parse(
            route === "Product/export-products"
              ? await response.text()
              : (await response.text())
            // : await decryptData(obj, await response.text())
          )
          return { data, status: response.status }
        }
      } else if (response.status === 401) {
        localStorage.clear()
        location.reload()
      } else {
        if (IsSkipData) {
          if (IsSkipUserLogin) {
            const data = await response.text();
            return { data, status: response.status }
          } else {
            const data = await response.json();
            return { data, status: response.status }
          }
        } else {
          // const data = await decryptData(obj, await response.text())
          const data = (await response.text())
          return { data, status: response.status }
        }
      }
    } catch (error) {
      return { data: `${isConnected ? "Please kindly contact the administrator for further assistance" : "Check Your Internet"}`, status: 505 }
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  const putApi = async (route, body) => {
    const obj = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : ""
    var headers = new Headers()
    headers.append("accept", "*/*")
    headers.append("Authorization", `Bearer ${obj.Token}`)
    headers.append("Content-Type", "application/json")
    const IsBaseURLChange = routsBaseURLChange?.some(option => option.includes(route))

    var requestOptions = {
      method: "PUT",
      headers: headers,
      body:
        body == "" || body == undefined
          ? ""
          : JSON.stringify(body),
      // : await encryptData(obj, JSON.stringify(body)),
      redirect: "follow",
    }

    let res = await fetch(
      `${IsBaseURLChange ? appConfig.TM_BASE_URL : appConfig.BASE_URL}/${route}`,
      requestOptions
    ).then(async response => {
      if (response.status === 200) {
        return {
          data: JSON.parse(await response.text()),
          // data: JSON.parse(await decryptData(obj, await response.text())),
          status: response.status,
        }
      } else if (response.status === 401) {
        localStorage.clear()
        location.reload()
      } else {
        return {
          data: (await response.text()),
          // data: await decryptData(obj, await response.text()),
          status: response.status,
        }
      }
    })
    return res
  }

  const deleteApi = async route => {
    const obj = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : ""
    var headers = new Headers()
    headers.append("accept", "*/*")
    headers.append("Authorization", `Bearer ${obj.Token}`)
    const IsBaseURLChange = routsBaseURLChange?.some(option => option.includes(route))

    var requestOptions = {
      method: "DELETE",
      headers: headers,
      redirect: "follow",
    }

    const [path, queryParamsString] = route.split('?');
    const queryParams = queryParamsString.split('&');
    const modifiedQueryParams = [];
    for (const param of queryParams) {
      const [key, value] = param.split('=');
      const modifiedValue =
        value == undefined
          ? ""
          : encodeURIComponent(obj, value);
      // : encodeURIComponent(await encryptData(obj, value));
      modifiedQueryParams.push(`${key}=${value}`);
    }
    var queryParameter = `${path}?${modifiedQueryParams.join('&')}`;

    // var value = route.split("=")[1]
    // value =
    //   value == undefined
    //     ? ""
    //     : encodeURIComponent(await encryptData(obj, value))
    // var queryParameter = route.split("=")[0] + (value == "" ? "" : "=" + value)

    let res = fetch(
      `${IsBaseURLChange ? appConfig.TM_BASE_URL : appConfig.BASE_URL}/${queryParameter}`,
      requestOptions
    ).then(async response => {
      if (response.status === 200) {
        return {
          data: JSON.parse(await response.text()),
          // data: JSON.parse(await decryptData(obj, await response.text())),
          status: response.status,
        }
      } else if (response.status === 401) {
        localStorage.clear()
        location.reload()
      } else {
        return {
          data: (await response.text()),
          // data: await decryptData(obj, await response.text()),
          status: response.status,
        }
      }
    })
    return res
  }

  const activeInavtiveApi = async (route) => {
    const obj = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : ""
    var myHeaders = new Headers()
    myHeaders.append("accept", "*/*")
    myHeaders.append("Authorization", `Bearer ${obj.Token}`)
    const IsBaseURLChange = routsBaseURLChange?.some(option => option.includes(route))

    var value = route.split("=")[1] || ''
    value =
      value == undefined
        ? ""
        : encodeURIComponent(obj, value)
    // : encodeURIComponent(await encryptData(obj, value))
    var queryParameter = route.split("=")[0] + (value == "" ? "" : "=" + value)

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      redirect: "follow",
    }

    let res = fetch(
      `${IsBaseURLChange ? appConfig.TM_BASE_URL : appConfig.BASE_URL}/${queryParameter}`,
      requestOptions
    ).then(async response => {
      if (response.status === 200) {
        return {
          data: JSON.parse(obj, await response.text()),
          // data: JSON.parse(await decryptData(obj, await response.text())),
          status: response.status,
        }
      } else if (response.status === 401) {
        localStorage.clear()
        location.reload()
      } else {
        return {
          data: (obj, await response.text()),
          // data: await decryptData(obj, await response.text()),
          status: response.status,
        }
      }
    })
    return res
  }

  return {
    loading,
    error,
    getApi,
    postApi,
    putApi,
    deleteApi,
    activeInavtiveApi,
  }
}

export default useApi